import BatchTable from "./batchTable.container";

export default BatchTable;
